import { render } from "./LoginFormLogo.vue?vue&type=template&id=962683cc&scoped=true"
import script from "./LoginFormLogo.vue?vue&type=script&lang=js"
export * from "./LoginFormLogo.vue?vue&type=script&lang=js"

import "./LoginFormLogo.vue?vue&type=style&index=0&id=962683cc&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-962683cc"]])

export default __exports__